import { ValidationParams } from '@/interfaces'
import { TRUVID_CHANNEL_HANDLE_MAX_LENGTH, TRUVID_CHANNEL_HANDLE_MIN_LENGTH } from '@/services/constants'

/* PREDEFINED VALIDATION OBJECTS */

const Input: ValidationParams = {}
const InputStringRequired: ValidationParams = {
  required: true
}
const InputPhoneNumberRequired: ValidationParams = {
  required: true,
  // accepts:
  // (123) 456-7890
  // (123)456-7890
  // 123-456-7890
  // 123.456.7890
  // 1234567890
  // +31636363634
  // +3(123) 123-12-12
  // +3(123)123-12-12
  // +3(123)1231212
  // +3(123) 12312123
  // 075-63546725
  patternValidation: /^[+\d]?(\d\s?|\d{2}|\(\d{3}\)\s?|\d{3}[-\s.]?)\d{3}[-\s.]?\d{4,6}$/im
}
const InputCustomUrlRequired: ValidationParams = {
  required: true,
  maxLen: 256,
  patternValidation:
    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,256})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
}
const InputCustomChannelHandleRequired: ValidationParams = {
  required: true,
  maxLen: TRUVID_CHANNEL_HANDLE_MAX_LENGTH,
  minLen: TRUVID_CHANNEL_HANDLE_MIN_LENGTH,
  patternValidation: /^[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+)*$/
}
const InputStringMinMax: ValidationParams = {
  required: true,
  minLen: 5,
  maxLen: 10
}
const InputEmailRequired: ValidationParams = {
  required: true,
  email: true
}
const InputUrlOrDomainRequired: ValidationParams = {
  required: true,
  maxLen: 1000,
  patternValidation: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/
}

const InputUrl: ValidationParams = {
  maxLen: 200,
  url: true
}
const InputUrlRequired: ValidationParams = {
  required: true,
  maxLen: 1000,
  url: true
}
const InputUrlOptional: ValidationParams = {
  required: false,
  maxLen: 256,
  url: true
}
const InputDomainRequired: ValidationParams = {
  required: true,
  domain: true
}
const InputNumberRequired: ValidationParams = {
  required: true
}
const InputIntegerRequired: ValidationParams = {
  required: true,
  integer: true
}
const InputNumberMinMax: ValidationParams = {
  required: true,
  minVal: 5,
  maxVal: 10
}
const InputRadioRequired: ValidationParams = {
  required: true
}
const InputCheckboxRequired: ValidationParams = {
  checkboxN: 1
}
const InputMultiselectRequired: ValidationParams = {
  required: true
}
const InputMultiselectRequiredN: ValidationParams = {
  required: true,
  multiN: 3
}

export {
  Input,
  InputUrl,
  InputStringRequired,
  InputEmailRequired,
  InputUrlRequired,
  InputUrlOptional,
  InputDomainRequired,
  InputStringMinMax,
  InputIntegerRequired,
  InputNumberRequired,
  InputNumberMinMax,
  InputRadioRequired,
  InputCheckboxRequired,
  InputMultiselectRequired,
  InputMultiselectRequiredN,
  InputPhoneNumberRequired,
  InputCustomUrlRequired,
  InputCustomChannelHandleRequired,
  InputUrlOrDomainRequired
}
